import { render } from "./SectionHeader.vue?vue&type=template&id=c161bf7a&scoped=true"
const script = {}

import "./SectionHeader.vue?vue&type=style&index=0&id=c161bf7a&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c161bf7a"]])

export default __exports__